import React from 'react';

export default function NSO() {
  return <div>
    <h1>NSO</h1>
  </div>;
}